import React from 'react';
import "./SingleBarDesktop.scss";
import {Col, Row} from "antd";
import {LazyImage} from "../../../Components";
import {useHistory} from "react-router";

const style = {
    background: '#0092ff'
};

function SingleBarDesktop({item, LinkDispatcher}) {

    const history = useHistory()

    return (
        <Row gutter={[16, 4]} justify="center" className="component-row">
            <Col xs={{span: 24}} sm={{span: 24}} md={{span: 24}} lg={{span: 24}}>
                <div key={item.items[0].uid} className="single-bar pointer"
                     onClick={() => {
                         let res = item.items[0]?.link_to_uid?.replace("online-store-categories","shop")
                         // history.push(res)
                         LinkDispatcher(item.items[0].link_to, item.items[0])
                     }
                     }>
                    <>
                        {/*<img  src={item.items[0].image} alt=""/>*/}
                        <LazyImage type={'banner'} src={item.items[0].image_desktop}/>
                        <span className="block-title">{item.items[0].title}</span>
                    </>
                </div>
            </Col>
        </Row>
    )
}

export default SingleBarDesktop;
